module.exports = __webpack_public_path__ + "media/images/niq-edit-b149a0cd3bf0288836c7225b2e93fb0e.svg";